import type { InvoiceModule } from '@bc-library/interface'

export const INVOICE_SETTING_ACCESS_KEYS = [
  'settingsBankAccountsAccess',
  'settingsInvoicingInformationAccess',
  'settingsInvoicingTermsAccess',
  'settingsMailTemplatesAccess',
  'settingsExpenseCategoriesAccess',
  'settingsEInvoicingAccess',
] as const

export type InvoiceSettingAccessKey = typeof INVOICE_SETTING_ACCESS_KEYS[number]

export const hasAnyInvoiceSettingsAccess = (invoice?: InvoiceModule) => {
  if (!invoice)
    return false
  if (invoice.settingsAccess)
    return true
  if (INVOICE_SETTING_ACCESS_KEYS.some(key => invoice[key]))
    return true
  return !!invoice.isAccess
}

export const hasInvoiceSettingAccess = (
  invoice: InvoiceModule | undefined,
  key: InvoiceSettingAccessKey,
) => {
  if (!invoice)
    return false
  if (invoice.settingsAccess)
    return true
  if (!INVOICE_SETTING_ACCESS_KEYS.some(k => invoice[k]))
    return !!invoice.isAccess
  return !!invoice[key]
}
